module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"payTitulo":"Tips","payText":"A través de este servicio podrás facturar la propina a través del pago con tarjeta.","payBtn":"MORE INFORMATION"},"es":{"payTitulo":"Propinas","payText":"Through this service you can bill the tip through card payment.","payBtn":"MÁS INFORMACIÓN"}}')
  delete Component.options._Ctor
}
